var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center grey--text"},[_vm._v("Ver. "+_vm._s(_vm.semver))])}
var staticRenderFns = []

export { render, staticRenderFns }